import { render } from "./g-file-upload.vue?vue&type=template&id=be54ba5c&scoped=true"
import script from "./g-file-upload.vue?vue&type=script&lang=js"
export * from "./g-file-upload.vue?vue&type=script&lang=js"

import "./g-file-upload.vue?vue&type=style&index=0&id=be54ba5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be54ba5c"]])

export default __exports__